<script>
	import {onMount} from 'svelte';
	import Helper from '../Models/Helper';
	import Gallery from './Gallery.svelte';
	import GalleryState from '../States/Gallery';
	import Product from './Product.svelte';
	import ProductState from '../States/Product';
	import Render from './Render.svelte';
	import Styles from './Styles.svelte';

	export let erp = 0;
	export let shopify = 0;

	let container = {};
	let split = false;
	let load_hide = false;
	let load_remove = false;
	let zoom_show = false;
	let zoom_remove = true;

	function containerSize() {
		const total = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
		const top = container.getBoundingClientRect().top;
		const height = Math.round(total - top);
		container.style.height = `${height}px`;
	}

	function galleryChange(gallery) {
		if (!load_hide)
			if (gallery.loaded) {
				setTimeout(() => load_hide = true, 250);
				setTimeout(() => load_remove = true, 1500);
			}

		if (zoom_remove && gallery.zoomed) {
			zoom_remove = false;
			setTimeout(() => zoom_show = true, 30);
		}
		else if (!zoom_remove && !gallery.zoomed) {
			zoom_show = false;
			setTimeout(() => zoom_remove = true, 500);
		}
	}

	onMount(containerSize);
	GalleryState.subscribe(galleryChange);
	window.addEventListener('orientationchange', () => {
		const resized = () => {
			containerSize();
			window.removeEventListener('resize', resized);
			window.location.replace(window.location.href);
		};

		window.addEventListener('resize', resized);
		load_remove = false;
		load_hide = false;
	});

	if (erp) ProductState.erp(erp);
	else ProductState.shopify(shopify);
</script>

<style>
	div.phd-container {
		color: var(--phd-primary);
		display: flex;
		box-sizing: border-box;
		position: relative;
		background: var(--phd-background-primary);
	}

	div.phd-gallery,
	div.phd-product {
		transition: width .75s cubic-bezier(.12, .9, .68, 1.02);
		will-change: width;
	}

	div.phd-gallery {
		position: relative;
		width: 65%;
	}

	div.phd-product {
		position: relative;
		width: 35%;
	}

	div.phd-container.phd-split div.phd-gallery {
		width: 30%;
	}

	div.phd-container.phd-split div.phd-product {
		width: 70%;
	}

	div.phd-gallery-box,
	div.phd-product-box {
		position: absolute;
		top: 0; right: 0; bottom: 0; left: 0;
		overflow: hidden;
	}

	div.phd-zoom,
	div.phd-load {
		top: 0; right: 0; bottom: 0; left: 0;
		background: var(--phd-background-primary);
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		transition: opacity .5s ease-out;
		will-change: opacity;
		z-index: 100;
	}

	div.phd-zoom {
		background: var(--phd-background-secondary);
		opacity: 0;
	}

	div.phd-zoom.phd-show {
		opacity: 1;
	}

	div.phd-zoom div.phd-knob {
		position: absolute;
		top: 2em; right: 2em;
		z-index: 110;
	}

	div.phd-zoom div.phd-knob svg {
		padding-top: 27%;
	}

	div.phd-zoom img {
		object-fit: cover;
		object-position: right center;
		width: 100%;
		height: 100%;
	}

	:global(div.phd-load.phd_load_hide) {
		opacity: 0;
	}

	div.phd-spinner {
		display: inline-block;
		width: 5em;
		height: 5em;
		border: .5em solid rgba(0, 0, 0, .1);
		border-top-color: rgba(0, 0, 0, .5);
		border-radius: 50%;
		animation: spin 1s ease-in-out infinite;
	}

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}

	@media (min-width: 320px) and (max-width: 1023px) {
		div.phd-product {
			font-size: .75em;
		}
	}

	@media (min-width: 420px) and (max-width: 1024px) {
		div.phd-product {
			font-size: .9em;
		}
	}

	@media (max-width: 1024px) and (orientation: landscape) {
		div.phd-gallery,
		div.phd-product {
			width: 50%;
		}
	}

	@media (max-width: 1024px) and (orientation: portrait) {
		div.phd-container {
			flex-direction: column;
		}

		div.phd-gallery {
			height: 65%;
		}

		div.phd-product {
			height: 35%;
		}

		div.phd-gallery,
		div.phd-product {
			margin: 0;
			width: 100%;
			transition: height .75s cubic-bezier(.12, .9, .68, 1.02);
			will-change: height;
		}

		div.phd-container.phd-shrink div.phd-gallery,
		div.phd-container.phd-shrink div.phd-product {
			transition-duration: .3s;
		}

		div.phd-container.phd-shrink div.phd-gallery {
			width: 100%;
			height: 25%;
		}

		div.phd-container.phd-shrink div.phd-product {
			width: 100%;
			height: 75%;
		}

		div.phd-container.phd-split div.phd-gallery {
			width: 100%;
			height: 25%;
		}

		div.phd-container.phd-split div.phd-product {
			width: 100%;
			height: 75%;
		}
	}

	@media (min-width: 320px) and (max-width: 420px) and (orientation: portrait) {
		div.phd-gallery,
		div.phd-product {
			height: 50%;
		}
	}
</style>

<div bind:this="{container}" class="phd-container" class:phd-split="{$ProductState.basket}" class:phd-shrink="{$GalleryState.shrunken}">
	<div class="phd-gallery">
		<div class="phd-gallery-box">
			<Gallery/>
		</div>
	</div>
	<div class="phd-product">
		<div class="phd-product-box">
			<Product/>
		</div>
	</div>
	{#if !zoom_remove}
		<div class="phd-zoom" class:phd-show={zoom_show}>
			<div class="phd-knob phd-knob-close" on:click="{event => GalleryState.zoom()}">
				<svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352zm-97.2-245.3L249.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L224 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"></path></svg>
			</div>
			<img src="{$GalleryState.front.large}" alt="Uitvergroting"/>
		</div>
	{/if}
	{#if !load_remove}
		<div class="phd-load" class:phd_load_hide="{load_hide}">
			<div class="phd-spinner"></div>
		</div>
	{/if}
</div>

<Render/>
<Styles/>